export const MODEL_COMPARE_STICK_OFFSET_CORRECTION = -15;
